import { makeStyles } from '@material-ui/core/styles'

const stepCotentStyles = makeStyles(theme => ({
   container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
   },
   title: {
      fontSize: 14,
      fontWeight: 'bold',
      marginTop: theme.spacing(1)
   },
   content: {
      fontSize: 14,
      textAlign: 'center',
      marginTop: theme.spacing(1)
   }
}))

export default stepCotentStyles
